module.exports = __webpack_public_path__ + "img/superbrugsen.48af415f.png";